var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailGrn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8822 0.666626C16.6572 0.666626 18.7497 2.93079 18.7497 5.93329V11.6566C18.7497 13.1933 18.2063 14.5816 17.2188 15.5666C16.333 16.4491 15.1838 16.9166 13.8955 16.9166H5.68467C4.39884 16.9166 3.25051 16.45 2.36384 15.5666C1.37634 14.5816 0.833008 13.1933 0.833008 11.6566V5.93329C0.833008 2.93079 2.92551 0.666626 5.70051 0.666626H13.8822ZM13.8822 1.91663H5.70051C3.60467 1.91663 2.08301 3.60579 2.08301 5.93329V11.6566C2.08301 12.8591 2.49634 13.9333 3.24634 14.6808C3.89301 15.3266 4.73717 15.6666 5.68717 15.6666H13.8822C13.8838 15.665 13.8905 15.6666 13.8955 15.6666C14.8463 15.6666 15.6897 15.3266 16.3363 14.6808C17.0872 13.9333 17.4997 12.8591 17.4997 11.6566V5.93329C17.4997 3.60579 15.978 1.91663 13.8822 1.91663ZM15.1955 5.77396C15.413 6.04146 15.3722 6.43479 15.1047 6.65313L11.4013 9.66313C10.933 10.0348 10.373 10.2206 9.81384 10.2206C9.25634 10.2206 8.70051 10.0365 8.23551 9.66813L4.49801 6.65479C4.22884 6.43813 4.18717 6.04396 4.40301 5.77563C4.62051 5.50813 5.01384 5.46563 5.28217 5.68146L9.01634 8.69146C9.48551 9.06313 10.1463 9.06313 10.6188 8.68813L14.3155 5.68313C14.5838 5.46396 14.9772 5.50563 15.1955 5.77396Z",
    fill: "#5DE094"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailGrn);
export default __webpack_public_path__ + "static/media/email_grn.3716db13077799a9701155a035466977.svg";
export { ForwardRef as ReactComponent };